export default function Highlight2({ subtitle, topTitle, text, reverse }) {
  return (
    <section>
      <div className="my-4 flex justify-center font-['Inter']" tabIndex={0}>
        <div
          className={`${
            reverse
              ? "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lgjustify-between lg:flex-row-reverse "
              : "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lg:justify-between lg:flex-row "
          }`}
        >
          <div className="lg:w-1/2 px-16 pt-16 lg:p-16">
            <p className="text-orange-400 font-bold mb-1 lg:mt-0 mt-4">
            TRUSTED BY INDUSTRY LEADERS
            </p>
            <h3 className="medium-title">
            Serving clients from all over the world
            </h3>
          </div>
          <div className="lg:w-1/2 px-16 py-16 lg:p-16">
            <p className="text-secgray text-lg">We&apos;ve worked for companies and organizations like <a className="text-maingray underline" href="https://google.com" target="_blank">Google</a>, the <a className="text-maingray underline" href="https://worldbank.org" target="_blank">World Bank</a> and <a className="text-maingray underline" href="https://fedex.com" target="_blank">FedEx</a>, and have successfully deployed dozens of projects for government, Fortune 500 enterprises and international NGOs.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
